export class GdsgDeleteResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "key",
            "baseName": "key",
            "type": "string",
            "format": ""
        },
        {
            "name": "outcome",
            "baseName": "outcome",
            "type": "GdsgDeleteResultOutcomeEnum",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GdsgDeleteResult.attributeTypeMap;
    }
    constructor() {
    }
}
export var GdsgDeleteResultOutcomeEnum;
(function (GdsgDeleteResultOutcomeEnum) {
    GdsgDeleteResultOutcomeEnum["Deleted"] = "deleted";
    GdsgDeleteResultOutcomeEnum["NotFound"] = "notFound";
    GdsgDeleteResultOutcomeEnum["Conflict"] = "conflict";
    GdsgDeleteResultOutcomeEnum["Error"] = "error";
})(GdsgDeleteResultOutcomeEnum || (GdsgDeleteResultOutcomeEnum = {}));
